export const POPULAR_POSTS_DATA = {
  TITLE: "t3",
  URL: "t4",
  NO_OF_POSTS: "t5",
};
